<template>
    <!-- Left Sidebar -->

    <div
            class="col col-xl-3 order-xl-1 col-lg-6 order-lg-2 col-md-6 col-sm-6 col-12 d-none d-sm-none d-md-block"
    >
        <div class="ui-block">
            <div class="friend-item">
                <div class="friend-header-thumb">
                    <img src="/image/friend-groups-bg.png" alt="friend" />
                </div>

                <div v-if="signedIn === true" class="friend-item-content">
                    <div class="friend-avatar">
                        <div class="author-thumb">
                            <img :src="getAvatarLocal()" alt="author" />
                        </div>
                        <div class="author-content">
                            <router-link :to=" '/profile/' + $store.state.user.username" class="h5 author-name">@{{ $store.state.user.username }}</router-link>
                            <div class="country" v-if="$store.state.user.club === null ">No Club</div>
                            <div class="country" v-else>{{$store.state.user.club}}</div>
                        </div>
                    </div>

                    <div class="swiper-container" data-slide="fade">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide">
                                <div class="friend-count" data-swiper-parallax="-500">
                                    <a href="#" class="friend-count-item">
                                        <div class="h6">{{ getUserContributions.reviews }}</div>
                                        <div class="title">Reviews</div>
                                    </a>
                                    <a href="#" class="friend-count-item">
                                        <div class="h6">{{ getUserContributions.followings }}</div>
                                        <div class="title">Following</div>
                                    </a>
                                    <a href="#" class="friend-count-item">
                                        <div class="h6">{{ getUserContributions.followers }}</div>
                                        <div class="title">Followers</div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-else class="widget w-create-fav-page">
                    <div class="icons-block">
                        <svg
                                class="olymp-star-icon left-menu-icon"
                                data-toggle="tooltip"
                                data-placement="right"
                                data-original-title="FAV PAGE"
                        >
                            <use xlink:href="/svg-icons/sprites/icons.svg#olymp-star-icon" />
                        </svg>

                        <a href="#" class="more">
                            <svg class="olymp-three-dots-icon">
                                <use xlink:href="/svg-icons/sprites/icons.svg#olymp-three-dots-icon" />
                            </svg>
                        </a>
                    </div>

                    <div class="content">
                        <span>Be like them and</span>
                        <h3 class="title">Create your own Match Page!</h3>
                        <a
                                href="#"
                                class="btn btn-bg-secondary btn-sm"
                                data-toggle="modal"
                                data-target="#registration-login-form-popup"
                        >Start Now!</a>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="signedIn === true && showReviewBox === true && getUserDetails.user_type !== '1' " class="ui-block">
            <div class="ui-block-title">
                <h6 class="title">Post A Deal</h6>
            </div>
            <div class="ui-block-content">
                <!-- Widget Recent Topics -->

                <ul class="widget w-featured-topics">
                    <li>
                        <div class="content">
                            <a
                                    href="javascript:;"
                                    class="h6 title"
                                    @click="openDealSelectBox()"
                            >
                                <h5 class="dd">
                                    <svg style="fill:#00AEEF" class="olymp-dropdown-arrow-icon">
                                        <use xlink:href="/svg-icons/sprites/icons.svg#olymp-football-icon" />
                                    </svg>
                                    <span>Post Deal</span>
                                </h5>
                            </a>
                        </div>
                    </li>
                </ul>
                <!-- ... end Widget Recent Topics -->
            </div>
        </div>

        <div class="ui-block" style="max-height: 400px;overflow: auto;">
            <div class="ui-block-content">
                <Timeline id="matchdaydeals" sourceType="profile" :options="{ tweetLimit: '8' }" />
            </div>
        </div>
        <div class="ui-block">
            <div class="ui-block-content">
                <div class="widget w-about">
                    <a href="/" class="logo">
                        <div class="img-wrap">
                            <img src="/image/llogo.png" width="100" alt="Olympus" />
                        </div>
                        <div class="title-block">
                            <h6 class="logo-title">{{projectName}}</h6>
                            <div class="sub-title">SOCIAL NETWORK FOR FOOTBALL FANS</div>
                        </div>
                    </a>
                    <p>Matchdaydeals is everything around a matchday and the deals available. From travel, to hotel bookings, to restaurants, to transport, to betting, to car rentals. It is the go-to site for football fans looking for deals around matchday.</p>
                    <ul class="socials">
                        <li>
                            <a href="https://www.instagram.com/matchdaydeals" target="_blank">
                                <i class="fab fa-instagram" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.facebook.com/matchdaydeals" target="_blank">
                                <i class="fab fa-facebook-square" aria-hidden="true"></i>
                            </a>
                        </li>
                        <li>
                            <a href="https://www.twitter.com/matchdaydeals" target="_blank">
                                <i class="fab fa-twitter" aria-hidden="true"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <reviewBox />
    </div>

    <!-- ... end Left Sidebar -->
</template>

<script>
    import reviewBox from "@/components/Modals/reviewSystems/reviewBox";
    import { Timeline } from "vue-tweet-embed";
    import avta from "@/functions/getAvatar";
    import {mapState} from "vuex";

    var pageData = {
        projectName: "",
        userData: {},
        id: null,
        avatar: "",
        signedIn: false,
        showReviewBox: false,
        tweet: 0,
        userContributions: {},
    };

    export default {
        name: "LeftSideBar",
        data() {
            return pageData;
        },
        components: { reviewBox, Timeline },
        computed: mapState({
            getAvatar: state => state.user.avatar,
            getUsername: state=> state.user.username,
            getUserDetails: state => state.user,
            getUserContributions: state => state.contributions,
        }),
        methods: {
            openDealSelectBox() {
                $("#deal-select-box").modal("show");
            },
            // set match id for the review box
            setMatchId(val) {
                let matchId = this.$route.params.fixture_id;
                window.eventBus.$emit("matchID", matchId);
                window.eventBus.$emit("review_option", val);
            },
            checkUserData(userData) {
                if (userData !== "" || userData !== "undefined") {
                    this.userData = JSON.parse(userData);
                    this.signedIn = true;
                }
            },
            currentPage() {
                let path = this.$route.name;
                if (path === "HomeDefaultPage") {
                    this.showReviewBox = false;
                }else {
                    this.showReviewBox = true;
                }
            },
            getAvatarLocal() {
                // let userData = localStorage.fansData;
                return avta({state:{ av: this.getAvatar, us: this.getUsername }});
            },

        },
        mounted() {
            this.currentPage();

            let userData = localStorage.fansData;
            if (userData) {
                this.checkUserData(userData);
            }
            this.projectName = this.$store.state.projectName;
        },
        watch: {
            showReviewBox() {
                let path = this.$route.name;
                if (path === "HomeDefaultPage") {
                    this.showReviewBox = false;
                }
            }
        }
    };
</script>

<style>
    .friend-avatar .author-thumb img {
        border: 4px solid #fff;
        display: block;
        width: 98px;
        height: 98px;
    }
    .friend-count {
        margin-bottom: 0 !important;
    }
    .friend-item .swiper-container {
        padding-bottom: 0 !important;
    }
    .dd {
        color: #00AEEF;
        font-weight: bold;
    }
    .dd span {
        position: relative;
        top: -9px;
        left: 8px;
    }
</style>
